import { render } from "./CbsOverviewItem.vue?vue&type=template&id=4cb313e4&scoped=true&ts=true"
import script from "./CbsOverviewItem.vue?vue&type=script&lang=ts"
export * from "./CbsOverviewItem.vue?vue&type=script&lang=ts"

import "./CbsOverviewItem.vue?vue&type=style&index=0&id=4cb313e4&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cb313e4"]])

export default __exports__